import { styled } from '@mui/material'
import { Skeleton } from '@mui/material'

export const SkeltonStyle = styled(Skeleton)({
  borderRadius: '8px',
  backgroundColor: '#39393C'
})
